
module.exports = {
    dateFormat:'MM/DD/YYYY',
    pagination:{
        RECS_PER_PAGE: 80,
        TOTAL_RECS_PER_EMP: 30
    },
    totalWorkdays:21,
    dateDifference:-14,
    token:{
        secretKey:'keolis-hos',
        expiresIn:60*60*60  // (in seconds)
    },
    serverError:{
        "success":false, 
        "errMsg":"Server Error"
    },
    workdayCategory:{
        UNCERTIFIED: 'U',
        //UNCERTIFIEDPRE16 : 'UP16',
        CERTIFIED: 'C',
        CLAIM: 'L',
        PENDING_CLAIM:'PC',
        REJECTED_CLAIM:'RC',
        ACCEPTED_CLAIM:'AC',
        ADMIN_HOS_LOG : 'AHL',
	MANUALLY_UPDATE: 'MU',
        OUTLAW:'O',
        AUDIT_TRAIL:'AT'
    },
    ADMIN_ROLE: "Admin",
    apiUrls:{
        GET_NOTES:'/getnotes/:workdayId/:wdy_date',
        firebaseBaseurl:"results/object_interface/workday/",
        LOGIN_URL:'/login',
        GET_ACTIVITIES:'/getactivities',
        GETEMP_WORKDAYS_URL:'/workdays',
        GET_WORKDAY_URL:'/workday/:role/:workdayId/:certifyStatus/:empId/:workdayDate/:dutyActivityStatus',
        GETADMIN_WORKDAYS_URL:'/adminworkdays',
        GETADMIN_WORKDAYS_NCNP_URL:'/adminworkdaysncnp',
        POST_WORKDAY_URL:'/workdays/postworkday/',
        POST_NOTE_URL:'/notes/postnote/',
        ADD_NEW_WORKDAY_URL:'/workdays/addnewworkday/',
        RECERTIFY_WORKDAY_URL:'/workdays/recertifyWorkday',
        E_AND_D_ACTIVITIES_URL: '/workdays/eAndD/:empId/:date',
        SHIFT_TIMING: '/shift/:empId',
        GET_CONFIGURATIONS:'/getconfigurations',
        UPDATE_CONFIGURATION_URL : '/configurations/postconf',
        GETADMIN_HOS_LOGS:'/adminhoslogs',
        GETUSER_HOS_LOGS:'/userhoslogs',
        GETUSER_SERIES_LOGS:'/userserieslogs',
        GET_ALL_USER_SERIES_LOGS:'/alluserserieslogs',
        GETADMIN_SERIES_LOGS:'/adminserieslogs',
        GET_HOS_DETAILS:'/hosdetails/:role/:workdayId/:certifyStatus/:empId/:workdayDate/:dutyActivityStatus/:isPayDetail/:resetbreakNo?',
        POST_HOS_WORKDAY_URL:'/hoslogs/postworkday/',
        GET_EMPLOYEE_LIST:'/get_employee_list',
        GET_FRA_LIST:'/fra_reports_list',
        GET_FRA_DETAILS:'/fradetails/:role/:workdayId/:certifyStatus/:empId/:workdayDate/:dutyActivityStatus/:isPayDetail/:resetbreakNo?',
        GET_FAQ_PDF:'/pdf/:name',
        IS_PDF_AVAILABLE:'/ispdfavailable/:name',
        GET_EMPLOYEE_NAME:'/get_employee_name/:empId',
        FILE_UPLOAD:'/upload-avatar',
        HASTUS_TRANSFORM: '/hastus_transform/:foldername',
        DELETE_HASTUS_FILE: '/delete_hastusfile/:filename',
        GET_FRA_WORKDAY_DETAILS:'/fraworkdaydetails/',
        GET_MOBILE_DASHBOARD_DATA:'/getMobileDashboardData',
    },
    configurationstype : {
        NCNP_STATUS : 'ncnpstatus'
    },
    roles:{
        EMPLOYEE_ROLE: "Employee",
        ADMIN_ROLE: "Admin",
        FRA_ROLE:"FRA"
    },
    isImpersonateEditAllow : true,
    restrictions: {
        allowLoginOffDuty: false, //Allow employee to login even if he is off-duty. *Enabled for QA Build
        allowLoginAfterThreeMinutes: false, //Allow employee to login after 3 minutes of duty time ends
        allowCertifyBeforeThreeMinutes: false, //Allow to certify before 3 minutes of duty time ends
        allowCertifyAfterThreeMinutes: false, //Allow to certify after 3 minutes of duty time ends
        allowCertifyOnOffDuty: false, //Allow to certify even if off duty. *Enabled for QA Build
    },
    COVERED_SERVIE : [
        "Availability","Football","FuelCrew","Herder","HouseEng","PowerWash","Protect","ProtectUniform","ReadvSwitcher",
        "SwitchTender","WAD","WashCrew","WorkTrain","TermSwitcher"
    ],
    NON_COVERED_SERVICE : [
        "CTC","ETC","ERC","COB","PHYS","QUA","CRC","TTC"
    ],
    HASTUS_FILE_PATH:'D://Keolis//Hastusfiles//ToProcessTCE//',
    
};